export default "__VITE_ASSET__BRfBk$0r__"